module.exports = __webpack_public_path__ + "img/icon-product.40843f19.png";